import { Injectable } from '@angular/core';

const nw = window.nw;

interface IAuthSessionTicket {
    handle: number;
    ticket: Uint8Array;
}

@Injectable()
export class GreenworksService {
    constructor() {
    }

    async getAuthSessionTicket(): Promise<string> {
        try {
            const { ticket } = await new Promise<IAuthSessionTicket>((resolve, reject) => {
                nw.require('./greenworks').getAuthSessionTicket(resolve, reject);

                setTimeout(reject, 5000);
            });

            // @ts-ignore
            return ticket.toString('hex');
        } catch (err) {
            // Noop.
        }
    }
}